// doc: https://marked.js.org/using_pro#extensions
interface MarkdownToken {
  type: string;
  raw: string;
  videoType: string;
  title: string;
  url: string;
}

export const MarkdownVideoBlock = {
  name: "videoBlock",
  level: "block",
  start(src: string) {
    return src.match(/`(contentful|youtube|wistia): \[(.*?)\]\((.*?)\)`/)
      ?.index;
  },
  // eslint-disable-next-line consistent-return
  tokenizer(src: string) {
    const rule = /^`(contentful|youtube|wistia): \[(.*?)\]\((.*?)\)`/;
    const match = rule.exec(src);

    if (match) {
      return {
        type: "videoBlock",
        raw: match[0],
        videoType: match[1],
        title: match[2],
        url: match[3],
      };
    }
  },
  renderer(token: MarkdownToken) {
    switch (token.videoType) {
      case "contentful":
        return `<h3>${token.title}</h3><iframe class="markdown-video-block__video-embed" src="${token.url}"></iframe>`;
      case "youtube":
        return `<h3>${token.title}</h3><iframe class="markdown-video-block__video-embed" src="https://www.youtube.com/embed/${token.url}"></iframe>`;
      case "wistia":
        return `<h3>${token.title}</h3><iframe class="markdown-video-block__video-embed" src="https://fast.wistia.net/embed/iframe/${token.url}"></iframe>`;
      default:
        return null;
    }
  },
};
